import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

// Secondary count lines on the left axis (thin). avg_score is the primary
// line and lives on its own 1-5 right axis (see below).
const COUNT_LINES = [
  { key: 'very_positive', name: 'Very Positive', color: '#276749' },
  { key: 'positive', name: 'Positive', color: '#38A169' },
  { key: 'neutral', name: 'Neutral', color: '#A0AEC0' },
  { key: 'negative', name: 'Negative', color: '#DD6B20' },
  { key: 'very_negative', name: 'Very Negative', color: '#E53E3E' },
  { key: 'migration_related', name: 'Evolution', color: '#D69E2E', dashed: true },
  { key: 'urgent', name: 'Urgent', color: '#FFAE1E', dashed: true },
];

export default function SentimentTrendChart({ trends, loading }) {
  if (loading) {
    return <div className="chart-card__empty">Loading trend…</div>;
  }
  if (!trends || !trends.labels || trends.labels.length === 0) {
    return <div className="chart-card__empty">No trend data yet</div>;
  }

  const data = trends.labels.map((label, i) => {
    const point = { label };
    for (const l of COUNT_LINES) point[l.key] = trends[l.key]?.[i] ?? 0;
    // avg_score may be null on empty days — keep it null so the line breaks
    // rather than dropping to zero.
    point.avg_score = trends.avg_score?.[i] ?? null;
    return point;
  });

  return (
    <ResponsiveContainer width="100%" height={320}>
      <LineChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#EDF2F7" />
        <XAxis dataKey="label" tick={{ fontSize: 11 }} interval="preserveStartEnd" />
        <YAxis
          yAxisId="count"
          allowDecimals={false}
          tick={{ fontSize: 11 }}
          width={30}
        />
        <YAxis
          yAxisId="score"
          orientation="right"
          domain={[1, 5]}
          ticks={[1, 2, 3, 4, 5]}
          tick={{ fontSize: 11 }}
          width={28}
        />
        <Tooltip contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #E2E8F0' }} />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        {/* Primary: average sentiment score (1-5), navy, thick. */}
        <Line
          yAxisId="score"
          type="monotone"
          dataKey="avg_score"
          name="Avg Score"
          stroke="#00205C"
          strokeWidth={3}
          dot={false}
          connectNulls={false}
          isAnimationActive={false}
        />
        {COUNT_LINES.map((l) => (
          <Line
            key={l.key}
            yAxisId="count"
            type="monotone"
            dataKey={l.key}
            name={l.name}
            stroke={l.color}
            strokeWidth={1.5}
            dot={false}
            strokeDasharray={l.dashed ? '5 5' : undefined}
            isAnimationActive={false}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
}
